import React, { useState, useEffect } from 'react';
import './SessionDayModal.css';

interface SessionDayModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (color: string, label: string) => void;
  currentSession: string;
  year: number;
  month: number;
  day: number;
  existingSessionDay?: {
    color: string | null;
    label: string | null;
  } | null;
}

const SessionDayModal: React.FC<SessionDayModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  currentSession,
  year,
  month,
  day,
  existingSessionDay
}) => {
  const [selectedColor, setSelectedColor] = useState<string>('#ff6b6b');
  const [label, setLabel] = useState<string>('');

  // Predefined colors for session days
  const predefinedColors = [
    '#ff6b6b', // Red
    '#4ecdc4', // Teal
    '#45b7d1', // Blue
    '#96ceb4', // Green
    '#ffeaa7', // Yellow
    '#dda0dd', // Plum
    '#ffa07a', // Light Salmon
    '#87ceeb', // Sky Blue
    '#98d8c8', // Mint
    '#f7dc6f'  // Light Yellow
  ];

  // Generate random color if none exists
  const generateRandomColor = () => {
    return predefinedColors[Math.floor(Math.random() * predefinedColors.length)];
  };

  useEffect(() => {
    if (existingSessionDay) {
      setSelectedColor(existingSessionDay.color || generateRandomColor());
      setLabel(existingSessionDay.label || `Session ${currentSession}`);
    } else {
      setSelectedColor(generateRandomColor());
      setLabel(`Session ${currentSession}`);
    }
  }, [isOpen, existingSessionDay, currentSession]);

  const handleConfirm = () => {
    onConfirm(selectedColor, label.trim() || `Session ${currentSession}`);
    onClose();
  };

  const handleRandomColor = () => {
    setSelectedColor(generateRandomColor());
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay session-day-modal-overlay">
      <div className="modal-content session-day-modal">
        <div className="modal-header">
          <h3>🎮 Session Tag markieren</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="session-day-form">
          <div className="date-info">
            <p><strong>Tag:</strong> {day}. Monat {month + 1}, Jahr {year}</p>
          </div>

          <div className="color-selection">
            <label>Farbe auswählen:</label>
            <div className="color-grid">
              {predefinedColors.map((color) => (
                <button
                  key={color}
                  className={`color-option ${selectedColor === color ? 'selected' : ''}`}
                  style={{ backgroundColor: color }}
                  onClick={() => setSelectedColor(color)}
                  title={color}
                />
              ))}
            </div>
            <button className="random-color-btn" onClick={handleRandomColor}>
              🎲 Zufällige Farbe
            </button>
          </div>

          <div className="label-input">
            <label htmlFor="session-label">Label:</label>
            <input
              id="session-label"
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              placeholder={`Session ${currentSession}`}
              maxLength={50}
            />
          </div>

          <div className="preview">
            <div className="day-preview" style={{ backgroundColor: selectedColor }}>
              <span className="preview-label">{label || `Session ${currentSession}`}</span>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn secondary" onClick={onClose}>
            Abbrechen
          </button>
          <button className="btn primary" onClick={handleConfirm}>
            {existingSessionDay ? 'Aktualisieren' : 'Markieren'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionDayModal;